import React from 'react';

export default function PlaceholderPage({ title, subtitle }) {
  return (
    <div style={{ maxWidth: 980, margin: '0 auto', padding: '24px 16px' }}>
      <div
        style={{
          background: 'var(--white)',
          border: '1px solid var(--border-light)',
          borderRadius: 18,
          padding: 18,
          boxShadow: 'var(--shadow-sm)',
        }}
      >
        <h2 style={{ marginBottom: 6 }}>{title}</h2>
        <p style={{ color: 'var(--text-secondary)', marginBottom: 0 }}>{subtitle}</p>
      </div>
    </div>
  );
}